import { useState, useEffect } from 'react';
import { Bookmark } from 'lucide-react';
import { toast } from 'sonner';

const BOOKMARKS_KEY = 'transplacement_bookmarks';

export const useBookmarks = () => {
  const [bookmarks, setBookmarks] = useState(() => {
    const saved = localStorage.getItem(BOOKMARKS_KEY);
    return saved ? JSON.parse(saved) : [];
  });

  useEffect(() => {
    localStorage.setItem(BOOKMARKS_KEY, JSON.stringify(bookmarks));
  }, [bookmarks]);

  const addBookmark = (college) => {
    setBookmarks(prev => {
      if (prev.find(b => b.college_id === college.college_id)) return prev;
      return [...prev, college];
    });
    toast.success(`${college.name} added to bookmarks`);
  };

  const removeBookmark = (collegeId) => {
    setBookmarks(prev => prev.filter(b => b.college_id !== collegeId));
    toast.success('Removed from bookmarks');
  };

  const isBookmarked = (collegeId) => {
    return bookmarks.some(b => b.college_id === collegeId);
  };

  const toggleBookmark = (college) => {
    if (isBookmarked(college.college_id)) {
      removeBookmark(college.college_id);
    } else {
      addBookmark(college);
    }
  };

  return { bookmarks, addBookmark, removeBookmark, isBookmarked, toggleBookmark };
};

export const BookmarkButton = ({ college, className = '' }) => {
  const { isBookmarked, toggleBookmark } = useBookmarks();
  const bookmarked = isBookmarked(college.college_id);

  return (
    <button
      onClick={(e) => {
        e.stopPropagation();
        toggleBookmark(college);
      }}
      className={`bookmark-btn ${bookmarked ? 'active' : ''} ${className}`}
      aria-label={bookmarked ? 'Remove from bookmarks' : 'Add to bookmarks'}
      data-testid={`bookmark-${college.college_id}`}
    >
      <Bookmark className={`h-5 w-5 ${bookmarked ? 'fill-current' : ''}`} />
    </button>
  );
};

export default BookmarkButton;
